import React, { Component } from "react";
import './navbar.css'

export class Navbar extends Component {
  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-cstm bg-dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="#">
              Analytic<span>Dash</span>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDarkDropdown"
              aria-controls="navbarNavDarkDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="drop_d collapse navbar-collapse"
              id="navbarNavDarkDropdown"    
            >
              <select
                className="form-select form-select-sm form-select-md-lg ms-md-auto bg-dark text-white"
                name="selectCoin"
                style={{ width: "fit-content" }}
                onChange={this.props.handle_Submit}
              >
                <option value="bitcoin">Select Coin</option>
                <option value="avalanche-2">Avalanche (AVAX)</option>
                <option value="binancecoin">Binance (BNB)</option>
                <option value="bitcoin">Bitcoin (BTC) </option>
                <option value="cardano">Cardano (ADA)</option>
                <option value="decentraland">Decentraland (MANA)</option>
                <option value="dogecoin">Dogecoin (DOGE)</option>
                <option value="ethereum">Ethereum (ETH)</option>
                <option value="ripple">Ripple (XRP)</option>
                <option value="solana">Solana (SOL)</option>
                <option value="tether">Tether (USDT)</option>
              </select>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;
